const KEY = 'itsai.humanizer-entry';
const valid = (value: string | null): value is string => !!value && /^\/(en|ar|de|es|fr)\/ai-humanizer\/?$/.test(value);

export const captureHumanizerEntry = (search: string): string | null => {
    const source = new URLSearchParams(search).get('humanizer_source');
    if (!valid(source)) return null;
    const normalized = source.replace(/\/$/, '');
    try { if (!valid(sessionStorage.getItem(KEY))) sessionStorage.setItem(KEY, normalized); } catch { /* storage unavailable */ }
    return normalized;
};

const incoming = captureHumanizerEntry(window.location.search);
export const pendingHumanizerEntry = (): string | null => {
    try {
        const stored = sessionStorage.getItem(KEY);
        if (valid(stored)) return stored;
    } catch { /* storage unavailable */ }
    return incomingAcknowledged ? null : incoming;
};
let incomingAcknowledged = false;
export const acknowledgeHumanizerEntry = () => {
    incomingAcknowledged = true;
    try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
    const url = new URL(window.location.href);
    url.searchParams.delete('humanizer_source');
    window.history.replaceState(window.history.state, '', url.toString());
};
